import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=1b01340e&"
import script from "./MessageForm.vue?vue&type=script&lang=ts&"
export * from "./MessageForm.vue?vue&type=script&lang=ts&"
import style0 from "./MessageForm.vue?vue&type=style&index=0&id=1b01340e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports